<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    v-if="title || body"
    class="max-container"
  >
    <div class="w-full md:w-2/3">
      <h2
        v-if="title"
        :id="title.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '')"
      >{{ title }}</h2>
      <div
        v-if="body"
        class="body-1"
        v-html="body"
      />
      <slot name="cta" />
    </div>
  </div>
</template>

<script setup lang="ts">
interface SectionIntroProps {
  title?: string;
  body?: string;
}

withDefaults(defineProps<SectionIntroProps>(), {
  title: '',
  body: '',
});
</script>
